import { render, staticRenderFns } from "./DashboardStatusStatistics.vue?vue&type=template&id=4f0ac2ba&scoped=true&"
import script from "./DashboardStatusStatistics.vue?vue&type=script&lang=js&"
export * from "./DashboardStatusStatistics.vue?vue&type=script&lang=js&"
import style0 from "./DashboardStatusStatistics.vue?vue&type=style&index=0&id=4f0ac2ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0ac2ba",
  null
  
)

export default component.exports